import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import logoDark from '../assets/images/tumen fon LOGO.webp';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success(i18n.language === 'bg' ? 'Ð£ÑÐ¿ÐµÑˆÐ½Ð¾ ÑÐµ Ð°Ð±Ð¾Ð½Ð¸Ñ€Ð°Ñ…Ñ‚Ðµ!' : 'Successfully subscribed!');
      setEmail('');
    } catch (error) {
      toast.error(i18n.language === 'bg' ? 'Ð“Ñ€ÐµÑˆÐºÐ° Ð¿Ñ€Ð¸ Ð°Ð±Ð¾Ð½Ð¸Ñ€Ð°Ð½Ðµ' : 'Error subscribing');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#1a2332] text-white py-20 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src={logoDark} 
                alt="N94" 
                className="w-20 h-20 object-contain"
              />
              <div>
                <div className="font-heading text-2xl font-bold text-white mb-1">
                  Nationals '94
                </div>
                <div className="font-body text-sm text-gray-400">
                  Foundation
                </div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl font-semibold mb-6 text-white">
              {t('footer.links')}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to={`/${i18n.language}`} className="text-gray-400 hover:text-white transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to={`/${i18n.language}/about`} className="text-gray-400 hover:text-white transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to={`/${i18n.language}/events`} className="text-gray-400 hover:text-white transition-colors">
                  {t('nav.events')}
                </Link>
              </li>
              <li>
                <Link to={`/${i18n.language}/gallery`} className="text-gray-400 hover:text-white transition-colors">
                  {t('nav.gallery')}
                </Link>
              </li>
              <li>
                <Link to={`/${i18n.language}/shop`} className="text-gray-400 hover:text-white transition-colors">
                  {t('nav.shop')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-xl font-semibold mb-6 text-white">
              {t('footer.legal')}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="#" className="text-gray-400 hover:text-white transition-colors">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="#" className="text-gray-400 hover:text-white transition-colors">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link to="#" className="text-gray-400 hover:text-white transition-colors">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-xl font-semibold mb-6 text-white">
              {t('footer.newsletter')}
            </h3>
            <form onSubmit={handleNewsletterSubmit} className="space-y-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('footer.email')}
                data-testid="newsletter-input"
                required
                className="w-full bg-white/10 border border-white/20 px-4 py-3 text-white placeholder:text-gray-400 transition-colors outline-none focus:border-white"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="w-full bg-white text-[#1a2332] font-medium px-6 py-3 hover:bg-gray-200 transition-all duration-300 disabled:opacity-50"
              >
                {loading ? '...' : t('footer.subscribe')}
              </button>
            </form>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="Twitter">
                <Twitter className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="YouTube">
                <Youtube className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center space-y-3">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Nationals '94 Foundation. {t('footer.rights')}.
          </p>
          <p className="text-base">
            <span className="text-gray-500">Designed by </span>
            <a 
              href="https://www.instagram.com/digitalei8ht/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-semibold hover:opacity-80 transition-opacity"
            >
              <span className="text-white">Digital</span>
              <span style={{ color: '#9b6bcf' }}>Eight</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

